import { RENAMED_ICONS as t } from "./index.es670.js";
function u(r) {
  if (t[r])
    return t[r];
  const e = r == null ? void 0 : r.toLowerCase();
  for (const [o, f] of Object.entries(t))
    if (o.toLowerCase() === e)
      return f;
  return r;
}
export {
  u as getIconName
};
//# sourceMappingURL=index.es672.js.map
